var Vacancy = {
    lock: false,
    init: function (id) {
        $('#vacancy_form').submit(function (e) {
            e.preventDefault();
            if (!Vacancy.lock) {
                document.getElementById("vacancy_form").style.display = "none";
                Vacancy.lock = true;
                Api.post('/vacancies/submit',{
                    vacancy_id: id,
                    data: $('#vacancy_form').serialize()
                }, function(r) {
                    if(r.success) {
                        Alert.push([{
                            type: 'success',
                            text: '¡La vacante ha sido enviada exitosamente! Recuerda mantenerte atento a los medios oficiales.',
                            icon: 'check'
                        }]);
                       var dataForm = document.getElementById('form_body');
                       dataForm.innerHTML = "";
                       dataForm.innerHTML = '<div class="message blue big">Gracias por completar esta vacante. ¡Mucha suerte!</div>';
                    } else {
                        Alert.push([{
                            type: 'danger',
                            text: r.error.message,
                            icon: 'triangle-alert'
                        }]);
                    }
                });
                Vacancy.lock = false;
                document.getElementById("vacancy_form").style.display = "block";
            }
        });
    }
}
